import { AlignItems, JustifyContent } from '@payflip/types/product-builder';
import styled, { css, FlattenSimpleInterpolation } from 'styled-components';

export const Row = styled.div<{
  alignItems?: AlignItems;
  justifyContent?: JustifyContent;
  gap?: 'small' | 'medium' | 'large' | 'xlarge';
}>`
  display: flex;
  align-items: ${({ alignItems = 'stretch' }): string => alignItems};
  justify-content: ${({ justifyContent = 'normal' }): string => justifyContent};

  ${({ gap, theme }): FlattenSimpleInterpolation | undefined => {
    switch (gap) {
      case 'xlarge': {
        return css`
          gap: calc(${theme.spacing_unit_x4} * 2);
        `;
      }
      case 'large': {
        return css`
          gap: ${theme.spacing_unit_x4};
        `;
      }
      case 'medium': {
        return css`
          gap: ${theme.spacing_unit_x2};
        `;
      }
      case 'small': {
        return css`
          gap: ${theme.spacing_unit_x1};
        `;
      }
      default: {
        return;
      }
    }
  }}
`;
